import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '@environment/environment'
import {catchError} from 'rxjs/operators';
import {ErrorHandlerService} from '@helpers/error-handler.service';
import {of, throwError} from 'rxjs';

@Injectable({providedIn: 'root'})
export class BillService {
  constructor(private httpClient: HttpClient, private errorHandler: ErrorHandlerService) {
  }

  uploadBill$(file: File, siteId: number) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('siteId', String(siteId));

    // Let the browser set the multipart Content-Type (incl. boundary) — do NOT set it manually.
    return this.httpClient.post<any>(`${environment.apiUrl}Bills/upload`, formData).pipe(
      catchError(
        (error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);

          return throwError(error);
        }
      )
    );
  }

  // OCR health ping (config-level check; the OCR side never calls the LLM for this).
  // The API answers 200 with { reachable: false } when OCR is down; if the portal API
  // itself is unreachable we map the HTTP error to the same shape — health should
  // never toast an error, only report a state.
  health$() {
    return this.httpClient.get<any>(`${environment.apiUrl}Bills/health`).pipe(
      catchError(() => of({ reachable: false, error: 'Portal API unreachable' }))
    );
  }

  // Confirm-overwrite: commit an already-extracted bill (force write, no re-OCR).
  commitBill$(extraction: any, siteId: number, fileName: string) {
    return this.httpClient.post<any>(`${environment.apiUrl}Bills/commit`,
      { siteId, fileName, extraction }).pipe(
      catchError(
        (error: HttpErrorResponse) => {
          this.errorHandler.handleError(error);
          return throwError(error);
        }
      )
    );
  }
}
